import DRNButton from './ButtonType/BaseButton';
import Icon from './ButtonType/Icon';
import IconStart from './ButtonType/IconStart';
import IconEnd from './ButtonType/IconEnd';
import VARIANT from './ButtonType/constant/variant';
import SIZE from './ButtonType/constant/size';
DRNButton.Icon = Icon;
DRNButton.IconStart = IconStart;
DRNButton.IconEnd = IconEnd;
DRNButton.VARIANT = VARIANT;
DRNButton.SIZE = SIZE;
export default DRNButton;
